import { GlobalProviders } from '@/components/GlobalProviders';
import { Router } from '@/components/Router';

export const App = () => (
	<GlobalProviders>
		<Router />
	</GlobalProviders>
);
